import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import ToolSidebar from './ToolSidebar';
import { Home, ChevronRight } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const ToolLayout = ({ title, description, icon: Icon, children }) => {
  const location = useLocation();
  
  return (
    <div className="flex min-h-screen bg-gray-50 dark:bg-gray-900">
      <ToolSidebar />
      
      <main className="flex-1 lg:ml-72">
        <div className="container mx-auto px-4 py-8">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 mb-6">
            <Link to="/" className="hover:text-blue-600 dark:hover:text-blue-400 flex items-center gap-1">
              <Home className="w-4 h-4" />
              Home
            </Link>
            <ChevronRight className="w-4 h-4" />
            <Link to="/tools" className="hover:text-blue-600 dark:hover:text-blue-400">
              Tools
            </Link>
            <ChevronRight className="w-4 h-4" />
            <span className="text-gray-900 dark:text-white">{title}</span>
          </nav>

          {/* Tool Header */}
          <div className="mb-8">
            <div className="flex items-start gap-4 mb-4">
              {Icon && (
                <div className="p-4 rounded-xl bg-gradient-to-br from-blue-500 to-cyan-500">
                  <Icon className="w-8 h-8 text-white" />
                </div>
              )}
              <div className="flex-1">
                <h1 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-2">
                  {title}
                </h1>
                <p className="text-gray-600 dark:text-gray-300 text-lg">{description}</p>
              </div>
            </div>
          </div>

          {/* Tool Content */}
          <Card className="border-gray-200 dark:border-gray-800 mb-8">
            <CardContent className="pt-6">
              {children}
            </CardContent>
          </Card>

          {/* Ad Placement */}
          <div className="bg-gray-100 dark:bg-gray-800 rounded-lg p-8 text-center border-2 border-dashed border-gray-300 dark:border-gray-700">
            <p className="text-gray-500 dark:text-gray-400 text-sm">Advertisement Space</p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ToolLayout;